module.exports = __webpack_public_path__ + "img/Cookies.a88bf6bf.svg";